import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=23957550"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeaderLinks: require('/home/forge/farescraper.com/components/AppHeaderLinks.vue').default,IconsGlobe: require('/home/forge/farescraper.com/components/IconsGlobe.vue').default,AppLanguageCurrencyModal: require('/home/forge/farescraper.com/components/AppLanguageCurrencyModal.vue').default,IconsCall: require('/home/forge/farescraper.com/components/IconsCall.vue').default,ButtonTelephoneCall: require('/home/forge/farescraper.com/components/ButtonTelephoneCall.vue').default})
